// Demo industry token override. Used by Phase 3 to prove the theme switch
// works end-to-end. Overrides primary + accent + radius onto the base.
import { baseTokens } from '../_base/tokens.js';

export const demoTokens = {
  ...baseTokens,
  token: {
    ...baseTokens.token,
    colorPrimary: '#7c3aed',
    colorInfo: '#7c3aed',
    colorLink: '#7c3aed',
    colorPrimaryHover: '#6d28d9',
    colorLinkHover: '#6d28d9',
    colorPrimaryActive: '#5b21b6',
    borderRadius: 14,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  components: {
    ...baseTokens.components,
    Button: { borderRadius: 999 },
  },
};
